module.exports = __webpack_public_path__ + "img/capa-padrao-saude.814af7ef.png";